module.exports = __webpack_public_path__ + "img/ford.8dfb9cfc.svg";